import { render } from "./Course_Properties.vue?vue&type=template&id=4b138816"
import script from "./Course_Properties.vue?vue&type=script&lang=js"
export * from "./Course_Properties.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__